import { MetaPartnerApiClient } from '@fourthwall/services/dist/MetaPartnerApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useDeleteMetaConfigurationMutation = createMutationHook(
  MetaPartnerApiClient.deleteMetaConfiguration,
  {
    mutationKey: ['deleteMetaConfiguration'],
  },
)
